import { OverlayConfig, Overlay, OverlayModule } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ɵɵdefineInjectable, Injectable, Component, ɵɵinject, NgModule } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/cdk/overlay';

function ToastComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 2)(2, "div", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const msg_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("@fadeInOut", undefined);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(msg_r1);
} }
class ToastDataService {
    constructor() {
        this.messageMap = new Map();
    }
    get messages() {
        return Array.from(this.messageMap.values()).reverse();
    }
    updateMessage(msg) {
        const id = new Date().getTime();
        this.messageMap.set(id, msg);
        return id;
    }
    removeMessage(id) {
        this.messageMap.delete(id);
    }
    hasMessage() {
        return this.messageMap.size > 0;
    }
}
ToastDataService.ɵfac = function ToastDataService_Factory(t) { return new (t || ToastDataService)(); };
ToastDataService.ɵprov = ɵɵdefineInjectable({ factory: function ToastDataService_Factory() { return new ToastDataService(); }, token: ToastDataService, providedIn: "root" });
ToastDataService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastDataService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return []; }, null); })();

class ToastComponent {
    constructor(data) {
        this.data = data;
    }
}
ToastComponent.ɵfac = function ToastComponent_Factory(t) { return new (t || ToastComponent)(ɵngcc0.ɵɵdirectiveInject(ToastDataService)); };
ToastComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ToastComponent, selectors: [["mis-teams-toast"]], decls: 2, vars: 1, consts: [[1, "toast-container"], [4, "ngFor", "ngForOf"], [1, "toast-wrapper"], [1, "msg"]], template: function ToastComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ToastComponent_div_1_Template, 4, 2, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.data.messages);
    } }, dependencies: [ɵngcc1.NgForOf], styles: [".toast-container[_ngcontent-%COMP%]{transition:max-height .3s ease-in}.toast-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{position:relative;display:flex;justify-content:center}.toast-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;gap:20px;padding:14px 12px;background:#181f33;box-shadow:0 12px 17px rgba(0,0,0,.14),0 5px 22px rgba(0,0,0,.12),0 7px 8px rgba(0,0,0,.2);border-radius:4px;transition:all .3s ease-in;min-height:44px;transform-origin:top}.toast-wrapper[_ngcontent-%COMP%]   .msg[_ngcontent-%COMP%]{color:#fff;max-width:314px;flex:1 1 314px;font-size:14px;line-height:20px;letter-spacing:.2px}@media screen and (max-width:360px){.toast-wrapper[_ngcontent-%COMP%]   .msg[_ngcontent-%COMP%]{max-width:90vw;flex:1 1 90vw}}"], data: { animation: [
            trigger("fadeInOut", [
                transition(":enter", [
                    style({ opacity: "0", transform: "translateY(-50%)", height: "0" }),
                    animate("300ms ease-in", style({ opacity: "1", transform: "translateY(0)", height: "*" }))
                ]),
                transition(":leave", [animate("300ms ease-in", style({ opacity: "0", transform: "translateY(50%)" }))])
            ])
        ] } });
ToastComponent.ctorParameters = () => [
    { type: ToastDataService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastComponent, [{
        type: Component,
        args: [{ selector: "mis-teams-toast", template: "<div class=\"toast-container\">\n  <div *ngFor=\"let msg of data.messages\" @fadeInOut>\n    <div class=\"toast-wrapper\">\n      <div class=\"msg\">{{ msg }}</div>\n    </div>\n  </div>\n</div>\n", animations: [
                    trigger("fadeInOut", [
                        transition(":enter", [
                            style({ opacity: "0", transform: "translateY(-50%)", height: "0" }),
                            animate("300ms ease-in", style({ opacity: "1", transform: "translateY(0)", height: "*" }))
                        ]),
                        transition(":leave", [animate("300ms ease-in", style({ opacity: "0", transform: "translateY(50%)" }))])
                    ])
                ], styles: [".toast-container{transition:max-height .3s ease-in}.toast-container>div{position:relative;display:flex;justify-content:center}.toast-wrapper{display:flex;flex-direction:row;align-items:center;gap:20px;padding:14px 12px;background:#181f33;box-shadow:0 12px 17px rgba(0,0,0,.14),0 5px 22px rgba(0,0,0,.12),0 7px 8px rgba(0,0,0,.2);border-radius:4px;transition:all .3s ease-in;min-height:44px;transform-origin:top}.toast-wrapper .msg{color:#fff;max-width:314px;flex:1 1 314px;font-size:14px;line-height:20px;letter-spacing:.2px}@media screen and (max-width:360px){.toast-wrapper .msg{max-width:90vw;flex:1 1 90vw}}"] }]
    }], function () { return [{ type: ToastDataService }]; }, null); })();

class ToastService {
    constructor(overlay, data) {
        this.overlay = overlay;
        this.data = data;
        this.messagePromises = [];
        this.messageBuilder = {
            error: {
                simple: "Something went wrong. Please try again later.",
                400: "Bad Request! We are working to fix this.",
                401: "UNAUTHORISED",
                403: "Sorry for the interruption but seems like your session has expired. Please login again and continue",
                404: "Unable to find resource. Please try again later"
            },
            item: (item) => {
                return {
                    action: (act = "updated") => {
                        const success = `Successfully ${act} ${item}.`;
                        const failure = `Failed to ${act} ${item}.`;
                        return {
                            success,
                            failure
                        };
                    }
                };
            },
            short: (act = "updated") => {
                const success = `Successfully ${act}.`;
                const failure = `Failed to ${act}.`;
                return {
                    success,
                    failure
                };
            },
            simple: (...args) => args.join(" "),
            simplest: "Done!"
        };
        this.userProfilePortal = new ComponentPortal(ToastComponent);
    }
    displayMsg(msg, timeout = 3000) {
        var _a;
        const positionStrategy = this.overlay.position().global().centerHorizontally();
        if ((window === null || window === void 0 ? void 0 : window.innerWidth) < 600) {
            positionStrategy.bottom("48px");
        }
        else {
            positionStrategy.top("80px");
        }
        const config = new OverlayConfig({
            hasBackdrop: false,
            positionStrategy
        });
        if (!((_a = this.toastWrapperRef) === null || _a === void 0 ? void 0 : _a.hasAttached())) {
            this.toastWrapperRef = this.overlay.create(config);
            this.toastWrapperRef.attach(this.userProfilePortal);
        }
        const messageId = this.data.updateMessage(msg);
        this.messagePromises.push(new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(this.data.removeMessage(messageId));
                if (!this.data.hasMessage()) {
                    this.closeToastOverlay();
                }
                // adding 300ms for entry animation
            }, timeout + 300);
        }));
        Promise.race(this.messagePromises).then(() => { });
    }
    // tslint:disable-next-line
    closeToastOverlay() {
        return setTimeout(() => {
            var _a;
            this.messagePromises = [];
            (_a = this.toastWrapperRef) === null || _a === void 0 ? void 0 : _a.detach();
            // adding 300ms for exit animation
        }, 300);
    }
}
ToastService.ɵfac = function ToastService_Factory(t) { return new (t || ToastService)(ɵngcc0.ɵɵinject(ɵngcc2.Overlay), ɵngcc0.ɵɵinject(ToastDataService)); };
ToastService.ɵprov = ɵɵdefineInjectable({ factory: function ToastService_Factory() { return new ToastService(ɵɵinject(Overlay), ɵɵinject(ToastDataService)); }, token: ToastService, providedIn: "root" });
ToastService.ctorParameters = () => [
    { type: Overlay },
    { type: ToastDataService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: ɵngcc2.Overlay }, { type: ToastDataService }]; }, null); })();

class ToastModule {
    static forRoot() {
        return {
            ngModule: ToastModule,
            providers: [ToastDataService, ToastService]
        };
    }
    static forChild() {
        return {
            ngModule: ToastModule,
            providers: [ToastDataService, ToastService]
        };
    }
}
ToastModule.ɵfac = function ToastModule_Factory(t) { return new (t || ToastModule)(); };
ToastModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ToastModule });
ToastModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, OverlayModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastModule, [{
        type: NgModule,
        args: [{
                declarations: [ToastComponent],
                imports: [CommonModule, OverlayModule],
                entryComponents: [ToastComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ToastModule, { declarations: function () { return [ToastComponent]; }, imports: function () { return [CommonModule, OverlayModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ToastDataService, ToastModule, ToastService, ToastComponent as ɵa };

